// TODO: Update to match css breakpoints once agreed with designer
const cssBreakpoints = {
  l: 1920,
  m: 1024,
  s: 624,
  mobileSmall: 480,
  small: 1023,
};

export default cssBreakpoints;
